import { jsx as _jsx } from "react/jsx-runtime";
export var Option = function (_a) {
    var option = _a.option, selected = _a.selected, onSelect = _a.onSelect, caption = _a.caption;
    return (_jsx("button", { className: "select-button ".concat(selected ? 'selected' : ''), onClick: function () { return onSelect(option); }, children: caption && caption }));
};
